import { cn } from './cn.js';

import type { LucideIcon } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

interface GlassEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
  className?: string;
}

export function GlassEmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: GlassEmptyStateProps): ReactElement {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 text-center', className)}>
      <div className="flex items-center justify-center w-12 h-12 rounded-xl glass glass-glow mb-4">
        <Icon size={24} className="text-text-tertiary" />
      </div>
      <h3 className="text-sm font-semibold text-text mb-1">{title}</h3>
      <p className="text-sm text-text-secondary max-w-sm">{description}</p>
      {action !== undefined && <div className="mt-4">{action}</div>}
    </div>
  );
}
